/*
  DO NOT EDIT THIS FILE! It will be replaced at build time.
*/
export const VERSION_INFO = {
  tag: '',
  branch: '',
  commit: '',
};



// WEBPACK FOOTER //
// src/VERSION.js